import { Route, Routes } from 'react-router-dom';
import ProfilePage from '../home-auth/ProfilePage';
import ChangePassword from '../change-password/ChangePassword';
import { ProtectedRoute } from 'orinabiji-auth-react';

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ProtectedRoute component={<ProfilePage />} />} />
      <Route path="/profile" element={<ProtectedRoute component={<ProfilePage />} />} />
      <Route path="/change-password" element={<ProtectedRoute component={<ChangePassword />} />} />
    </Routes>
  );
};
